
export const messages = {
  en: {
    message: {
      generating: 'Generating video. This will take a while. Please be patient.',
      explanation: 'Fill in your Raspberry Shake station name, pick one of the available ' +
                   'stations, either pick an event or fill in the time manually and download ' +
                   'an audio version of the seismic activity for that station at that time.',
      reports: 'Send bug reports to',
      station_label: 'Station (e.g., R27F1)',
      channel_label: 'Channel',
      loading_events: 'Loading recent events...',
      recent_events_label: 'Recent events',
      trace_startdate_label: 'Trace start date (UTC)',
      trace_starttime_label: 'Trace start time (UTC)',
      trace_length_label: 'Trace length (s, max 1000)',
      speed_label: 'Playback speed',
      speed_x1_label: 'Normal (ideal for teleseismic EQs)',
      speed_x2_label: 'Twice as slow',
      speed_x4_label: 'Four times slower (ideal for small local EQs)',
      download_label: 'Download'
    }
  },
  fr: {
    message: {
      generating: 'Génération de la vidéo. Cela peut prendre du temps. Patientez s\'il vous plaît.',
      explanation: 'Remplissez le nom de votre station Raspberry Shake, choisissez ' +
                   'l\'une des stations disponibles, choisissez un événement ou remplissez ' +
                   'l\'heure manuellement et téléchargez une version audio de l\'activité ' +
                   'sismique pour cette station au moment choisi.',
      reports: 'Envoyer des rapports de bugs à',
      station_label: 'Station (e.g., R27F1)',
      channel_label: 'Canal',
      loading_events: 'Charger des événements récents...',
      recent_events_label: 'Événements récents',
      trace_startdate_label: 'Initialisation date de la trace  (UTC)',
      trace_starttime_label: 'Initialisation temps de la trace (UTC)',
      trace_length_label: 'Longueur de la trace (s, max 1000)',
      speed_label: 'Vitesse de lecture',
      speed_x1_label: 'Normal (idéal pour les séismes lointains)',
      speed_x2_label: 'Deux fois plus lent',
      speed_x4_label: 'Quatre fois plus lent (idéal pour les petits séismes locaux)',
      download_label: 'Télécharger'
    }
  },
  es: {
    message: {
      generating: 'Generando video. Esto tardará un poco. Por favor ser paciente.',
      explanation: 'Digite el nombre de la estación de su Raspberry Shake, seleccione una de las que están disponibles' +
                   ', puede seleccionar un evento o digitar el tiempo manualmente, luego presione descargar para obtener' +
                   ' una versión de audio de la actividad sísmica para la estación y el tiempo seleccionados.',
      reports: 'Envíe reportes de bugs a',
      station_label: 'Estación (e.g., R27F1)',
      channel_label: 'Canal',
      loading_events: 'Cargando eventos recientes...',
      recent_events_label: 'Eventos recientes',
      trace_startdate_label: 'Inicio fecha de la traza (UTC)',
      trace_starttime_label: 'Inicio hora de la traza (UTC)',
      trace_length_label: 'Loongitud de la traza (s, max 1000)',
      speed_label: 'Velocidad de reproducción',
      speed_x1_label: 'Normal (ideal para sismos distantes)',
      speed_x2_label: 'El doble de lento',
      speed_x4_label: 'Cuatro veces más lento (ideal para sismos locales pequeños)',
      download_label: 'Descargar'
    }
  },
  nl: {
    generating: 'Genereren van de video is begonnen, dit kan even duren..',
    explanation: 'Vul eerst de Raspberry Shake station naam in en kies een van de beschikbare ' +
                 'eenheden, kies daarna het geschikt kanaal. Je kan ofwel een van de laatste ' +
                 'aardbevingen kiezen, of de tijd and duur van de gewilde seismische activiteit' +
                 ' handmatig invullen.',
    reports: 'Stuur eventuele bugs naar',
    station_label: 'Station (bv. R27F1)',
    channel_label: 'Kanaal',
    loading_events: 'Bezig met ophalen van de laatste aardbevingen',
    recent_events_label: 'Recente activiteiten',
    trace_startdate_label: 'Trace start datum (UTC)',
    trace_starttime_label: 'Trace start tijd (UTC)',
    trace_length_label: 'Trace duur (s, max 1000)',
    speed_label: 'Afspeel snelheid',
    speed_x1_label: 'Normaal (ideaal voor teleseismische aardbevingen)',
    speed_x2_label: 'Twee keer zo traag',
    speed_x4_label: 'Vier keer zo traag (ideaal voor kleine en lokale aardbevingen)',
    download_label: 'Download'
  }
}
